import clsx from 'clsx';
import React, { FC } from 'react';

import { getFormattedPrice } from '../../helpers/price';

interface TotalTableProps {
  data: {
    id: string;
    name: string;
    rate: string;
    rublesAmount: string;
  }[];
}

const TotalTable: FC<TotalTableProps> = ({ data }) => {
  return (
    <>
      {data.map((item, index) => (
        <React.Fragment key={`${item.id}-${index}`}>
          <div
            className={clsx('no-left-border', {
              'customs-payments-total': data.length - 1 === index,
            })}
          >
            {item.name}
          </div>
          {data.length - 1 !== index && <div className="center">{item.rate}</div>}
          <div className="center">{getFormattedPrice(+item.rublesAmount, 2)} RUB</div>
        </React.Fragment>
      ))}
    </>
  );
};

export default TotalTable;
